export { default } from './isImmutableList'
